/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* Tab  */
document.addEventListener("DOMContentLoaded", function () {
  var tabs = document.getElementsByClassName("c-tab");
  for (let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener("click", tabSwitch);
  }
  function tabSwitch() {
    var ancestorEle = this.closest(".c-tab-panel");
    ancestorEle.getElementsByClassName("is-active")[0].classList.remove("is-active");
    this.classList.add("is-active");
    ancestorEle.getElementsByClassName("is-show")[0].classList.remove("is-show");
    var groupTabs = ancestorEle.getElementsByClassName("c-tab");
    var arrayTabs = Array.prototype.slice.call(groupTabs);
    var index = arrayTabs.indexOf(this);
    ancestorEle.getElementsByClassName("c-panel")[index].classList.add("is-show");
  }
});

/* acrdion */
var ac_toggle = document.querySelectorAll(".c-acordion__toggle");
function toggle() {
  var content = this.nextElementSibling;
  this.classList.toggle("is-active");
  content.classList.toggle("is-open");
}
for (let i = 0; i < ac_toggle.length; i++) {
  ac_toggle[i].addEventListener("click", toggle);
}

/* Reserve Btn */
document.addEventListener("DOMContentLoaded", function () {
  const reservedBtn = document.getElementById("reservedBtn");
  const reservedWrapper = document.getElementById("reservedWrapper");

  if (!reservedBtn || !reservedWrapper) {
    return;
  }

  reservedBtn.addEventListener("click", function () {
    reservedBtn.classList.add("is-hidden");
    reservedWrapper.classList.remove("is-hidden");
  });
});

/* Custom Footer Top - Mobile */
document.addEventListener("DOMContentLoaded", function () {
  const footerLists = document.querySelectorAll(".c-footer-top-links__list");

  if (!footerLists) return;

  footerLists.forEach((list) => {
    const title = list.querySelector(".c-footer-top-links__item--title");
    if (!title) return;

    // SP時のみクリックイベントを有効に
    function toggleSP() {
      if (window.innerWidth <= 741) {
        title.style.cursor = "pointer";
        list.classList.add("is-accordion");
      } else {
        title.style.cursor = "";
        list.classList.remove("is-accordion");
        list.classList.remove("is-open");
      }
    }

    // 初期設定
    toggleSP();

    // クリックイベント
    title.addEventListener("click", () => {
      if (window.innerWidth <= 741) {
        list.classList.toggle("is-open");
      }
    });

    // リサイズ時の制御
    window.addEventListener("resize", toggleSP);
  });
});

/* Contact - product name and URL parameters */
document.addEventListener("DOMContentLoaded", function () {
  // URLのクエリパラメーターを取得
  const urlParams = new URLSearchParams(window.location.search);
  const productName = urlParams.get("product_name");
  const productUrl = urlParams.get("product_url");

  // 商品名の設定
  const productNameInput = document.getElementById("contact-form-product-name");
  if (productNameInput) {
    if (productName) {
      productNameInput.value = decodeURIComponent(productName);
      productNameInput.classList.add("is-filled");
    }

    // 入力時のクラス制御を追加
    productNameInput.addEventListener("input", function () {
      if (this.value) {
        this.classList.add("is-filled");
      } else {
        this.classList.remove("is-filled");
      }
    });
  }

  // 商品ページURLの設定
  const productUrlInput = document.getElementById("contact-form-product-url");
  if (productUrlInput) {
    if (productUrl) {
      // ショップのドメインを取得
      const shopDomain = window.location.origin;
      // 完全なURLを構築
      const fullProductUrl = `${shopDomain}${decodeURIComponent(productUrl)}`;

      productUrlInput.value = fullProductUrl;
      productUrlInput.classList.add("is-filled");
    }

    // 入力時のクラス制御を追加
    productUrlInput.addEventListener("input", function () {
      if (this.value) {
        this.classList.add("is-filled");
      } else {
        this.classList.remove("is-filled");
      }
    });
  }
});

/* Mega Menu - Tab Switch */
document.addEventListener("DOMContentLoaded", () => {
  const categoryLinks = document.querySelectorAll(".MegaMenuCategory__TabItem");

  const activateTab = (element) => {
    const parentMenu = element.getAttribute("data-parent-menu");
    if (!parentMenu) return;

    // 同じ親メニュー内のタブをリセット
    document.querySelectorAll(`.MegaMenuCategory__TabItem[data-parent-menu="${parentMenu}"]`).forEach((tab) => tab.classList.remove("is-active"));

    element.classList.add("is-active");

    // 同じ親メニュー内のコンテンツをリセット
    document.querySelectorAll(`.Item__Wrap[data-parent-menu="${parentMenu}"]`).forEach((item) => item.classList.remove("active"));

    const tabIndex = element.getAttribute("data-tab-item");
    const target = document.getElementById(`category-tab-${parentMenu}-${tabIndex}`);
    if (target) {
      target.classList.add("active");
    }
  };

  categoryLinks.forEach((element) => {
    element.addEventListener("mouseover", () => activateTab(element));
    element.addEventListener("click", () => activateTab(element));
  });
});

/* Mega Menu - Auto Height */
document.addEventListener("DOMContentLoaded", () => {
  const setMegaMenuHeight = () => {
    requestAnimationFrame(() => {
      try {
        const header = document.querySelector(".header");
        const announcementBar = document.querySelector(".announcement-bar");
        const megaMenuTabs = document.querySelectorAll(".MegaMenuCategory__Tab");
        const megaMenuContents = document.querySelectorAll(".MegaMenuCategory__Content");

        if (!header || (!megaMenuTabs.length && !megaMenuContents.length)) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const headerHeight = Math.max(header.offsetHeight || 0, 0);
        const announcementHeight = announcementBar ? Math.max(announcementBar.offsetHeight || 0, 0) : 0;

        const finalHeight = scrollTop <= 0 ? `calc(100vh - ${headerHeight + announcementHeight}px)` : `calc(100vh - ${headerHeight}px)`;

        megaMenuTabs.forEach((tab) => {
          tab.style.height = finalHeight;
        });
        megaMenuContents.forEach((content) => {
          content.style.height = finalHeight;
        });
      } catch (error) {
        console.warn("Mega Menu height calculation error:", error);
      }
    });
  };

  setMegaMenuHeight();

  const debouncedResize = () => requestAnimationFrame(setMegaMenuHeight);
  window.addEventListener("scroll", debouncedResize);
  window.addEventListener("resize", debouncedResize);
});

// Custom Top Btn - smooth scroll
window.addEventListener("DOMContentLoaded", function () {
  document.getElementById("link_page_top").style.visibility = "hidden";

  document.getElementById("link_page_top").addEventListener("transitionend", function () {
    if (document.getElementById("link_page_top").className !== "view") {
      document.getElementById("link_page_top").style.visibility = "hidden";
    }
  });

  window.addEventListener("scroll", function () {
    if (200 < window.scrollY) {
      document.getElementById("link_page_top").style.visibility = "visible";
      document.getElementById("link_page_top").classList.add("view");
    } else {
      document.getElementById("link_page_top").classList.remove("view");
    }
  });
});

// Header - DesktopNav 背景色とメニューのチラつき対策
document.addEventListener("DOMContentLoaded", () => {
  const desktopNav = document.querySelector("desktop-navigation");
  const storeHeader = document.querySelector("store-header");
  const announcementBar = document.querySelector(".shopify-section--announcement-bar");
  // announcementBarの子要素は、親要素が存在する場合のみ取得を試みる
  const innerAnnouncementBar = announcementBar ? announcementBar.querySelector(".announcement-bar") : null;
  const announcementText = announcementBar ? announcementBar.querySelector("p") : null;

  // 必須要素のチェック - デスクトップナビゲーションとストアヘッダーが必要
  if (!desktopNav || !storeHeader) return;

  let isHoveringMenu = false;

  desktopNav.addEventListener("mouseenter", () => {
    isHoveringMenu = true;
    // store-headerの処理は必ず実行
    storeHeader.classList.remove("header--transparent");
    storeHeader.style.background = "rgb(var(--header-background))";

    // アナウンスバー関連の処理は、要素が存在する場合のみ実行
    if (announcementBar) {
      announcementBar.classList.remove("shopify-section--header--transparent");
      announcementBar.style.background = "rgb(var(--section-background))";
      announcementBar.style.boxShadow = "0 1px rgb(var(--border-color))";

      if (announcementText) {
        announcementText.style.color = "rgb(var(--text-color))";
      }
    }
    if (innerAnnouncementBar) {
      innerAnnouncementBar.style.background = "rgb(var(--section-background))";
    }
  });

  desktopNav.addEventListener("mouseleave", () => {
    isHoveringMenu = false;
    // store-headerの処理は必ず実行
    storeHeader.style.background = "";

    // アナウンスバー関連の処理は、要素が存在する場合のみ実行
    if (announcementBar) {
      announcementBar.style.background = "";
      announcementBar.style.boxShadow = "";

      if (announcementText) {
        announcementText.style.color = "";
      }
    }
    if (innerAnnouncementBar) {
      innerAnnouncementBar.style.background = "";
    }
  });

  // store-headerの監視は必ず実行
  const headerObserver = new MutationObserver((mutations) => {
    if (isHoveringMenu) {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
          if (storeHeader.classList.contains("header--transparent")) {
            storeHeader.classList.remove("header--transparent");
          }
        }
      });
    }
  });
  headerObserver.observe(storeHeader, { attributes: true });

  // アナウンスバーの監視は、要素が存在する場合のみ実行
  if (announcementBar) {
    const announcementObserver = new MutationObserver((mutations) => {
      if (isHoveringMenu) {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            if (announcementBar.classList.contains("shopify-section--header--transparent")) {
              announcementBar.classList.remove("shopify-section--header--transparent");
            }
            if (!announcementBar.style.boxShadow) {
              announcementBar.style.boxShadow = "0 1px rgb(var(--border-color))";
            }
            if (announcementText && !announcementText.style.color) {
              announcementText.style.color = "rgb(var(--text-color))";
            }
          }
        });
      }
    });
    announcementObserver.observe(announcementBar, { attributes: true });

    // innerAnnouncementBarの監視も、要素が存在する場合のみ実行
    if (innerAnnouncementBar) {
      const innerAnnouncementObserver = new MutationObserver((mutations) => {
        if (isHoveringMenu) {
          mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "style") {
              if (innerAnnouncementBar.style.background === "transparent") {
                innerAnnouncementBar.style.background = "rgb(var(--section-background))";
              }
            }
          });
        }
      });
      innerAnnouncementObserver.observe(innerAnnouncementBar, { attributes: true, attributeFilter: ["style"] });
    }
  }
});
